// Minimal API client for CEAC NIV status

export async function getSession() {
  const resp = await fetch('/api/ceac/niv/session');
  if (!resp.ok) throw new Error(`session failed: ${resp.status}`);
  return await resp.json();
}

export async function refreshCaptcha(sessionId) {
  const resp = await fetch(`/api/ceac/niv/captcha?session_id=${encodeURIComponent(sessionId)}`);
  if (!resp.ok) throw new Error(`captcha failed: ${resp.status}`);
  return await resp.json();
}

export async function submitStatus(payload) {
  const resp = await fetch('/api/ceac/niv/status', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    const msg = data?.detail || `submit failed: ${resp.status}`;
    throw new Error(msg);
  }
  return data;
}

export async function getLocations(sessionId) {
  const resp = await fetch(`/api/ceac/niv/locations?session_id=${encodeURIComponent(sessionId)}`);
  if (!resp.ok) throw new Error(`locations failed: ${resp.status}`);
  return await resp.json();
}

// New flow
export async function start(payload) {
  const resp = await fetch('/api/ceac/niv/start', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data?.detail || `start failed: ${resp.status}`);
  return data;
}

export async function pollCaptcha2(taskId) {
  const url = `/api/ceac/niv/captcha2?task_id=${encodeURIComponent(taskId)}`;
  const resp = await fetch(url);
  if (resp.status === 202) return null;
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data?.detail || `captcha2 failed: ${resp.status}`);
  return data;
}

export async function verifyCaptcha2(taskId, captcha, phase) {
  const resp = await fetch('/api/ceac/niv/captcha/verify', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ task_id: taskId, captcha, phase }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data?.detail || `verify failed: ${resp.status}`);
  return data;
}

export async function pollResult(taskId) {
  const url = `/api/ceac/niv/result?task_id=${encodeURIComponent(taskId)}`;
  const resp = await fetch(url);
  if (resp.status === 202) return null;
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data?.detail || `result failed: ${resp.status}`);
  return data;
}

export async function refreshCaptcha2(taskId) {
  const url = `/api/ceac/niv/captcha/refresh?task_id=${encodeURIComponent(taskId)}`;
  const resp = await fetch(url);
  if (resp.status === 202) return null;
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data?.detail || `captcha refresh failed: ${resp.status}`);
  return data;
}
